import ContentPage from "./ContentPage";

export default function Terms() {
  return (
    <ContentPage title="Terms of service" eyebrow="Legal">
      <p className="lead">
        These terms are a placeholder for development. Publish finalized terms before accepting real orders.
      </p>
      <p>
        By using this site you agree to comply with applicable laws and our policies. Product availability, pricing, and descriptions may change without notice where permitted by law.
      </p>
    </ContentPage>
  );
}
